import { render, staticRenderFns } from "./branchesTable.vue?vue&type=template&id=6f3c0677&scoped=true&"
import script from "./branchesTable.vue?vue&type=script&lang=js&"
export * from "./branchesTable.vue?vue&type=script&lang=js&"
import style0 from "./branchesTable.vue?vue&type=style&index=0&id=6f3c0677&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3c0677",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f3c0677')) {
      api.createRecord('6f3c0677', component.options)
    } else {
      api.reload('6f3c0677', component.options)
    }
    module.hot.accept("./branchesTable.vue?vue&type=template&id=6f3c0677&scoped=true&", function () {
      api.rerender('6f3c0677', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/branches/branchesTable.vue"
export default component.exports